import {observer} from "mobx-react-lite";
import {NavigateNext} from "@mui/icons-material";
import {Breadcrumbs, Grid, Link, Typography} from "@mui/material";
import CircleIcon from '@mui/icons-material/Circle';
import type {MouseEventHandler} from "react";
import React from "react";
import {useStores} from "../../../../stores";
import {UNCATEGORIZED_LABEL, UNCATEGORIZED_VALUE} from "../../../../constants";
import {getBusinessUnitIdHack} from "../../../../stores/hacks/display";

type Props = {
    previousCategory?: boolean,
}
export const ReviewBreadcrumbs: React.FC<Props> = observer(({previousCategory = false}) => {
    const {bagStore, categorizationReviewStore, p} = useStores();
    const pageController = categorizationReviewStore.reviewPageController;
    const reviewPageFilterController = categorizationReviewStore.reviewPageController.reviewPageFilterController;

    const onClickBu: MouseEventHandler = e => {
        e.preventDefault();
        pageController.navigateToPage('welcome');
    }

    // const buEl = bagStore.bu.selectedBusinessUnit && (
    //     reviewPageFilterController.selectedLevel > 0 ?
    //         <Link onClick={onClickBu} href="">
    //             {bagStore.bu.selectedBusinessUnit.bu_name}
    //         </Link>
    //         : <Typography color="textPrimary" className="">
    //             {bagStore.bu.selectedBusinessUnit.bu_name}
    //         </Typography>
    // )
    const buEl = p.p.enableBuFilter && bagStore.bu.selectedBusinessUnitOption && (
        <Link onClick={onClickBu} href="">
            {bagStore.bu.selectedBusinessUnitOption.bu_name +
                (p.p.showBuWithId && bagStore.bu.selectedBusinessUnitOption.id > 0 ? ` (${getBusinessUnitIdHack(bagStore.bu.selectedBusinessUnitOption)})` : '')}
        </Link>
    )

    return <Grid container spacing={1} className="my-4">
        <Grid size={2}>
            <CircleIcon fontSize="small" color={previousCategory ? 'disabled' : 'primary'}/>
            <Typography component="span" color="textPrimary" className="ms-2">
                {previousCategory ? 'Previous ' : ''}Category
            </Typography>
        </Grid>
        <Grid size={10}>
            <Breadcrumbs separator={<NavigateNext fontSize="small"/>} className="d-inline-block"
                         aria-label={previousCategory ? 'breadcrumb-previous' : 'breadcrumb'}>
                {!previousCategory && buEl}
                {(previousCategory ? reviewPageFilterController.selectedPreviousCategory : reviewPageFilterController.selectedCategory).map((category, index) => {
                    const level = index + 1;
                    const categoryLabel = category === UNCATEGORIZED_VALUE ? UNCATEGORIZED_LABEL : category;
                    // const isLast = index === array.length - 1;
                    // if (isLast) {
                    //     return <Typography key={category} color="textPrimary" className="">{categoryLabel}</Typography>
                    // }
                    const onClick: MouseEventHandler = e => {
                        e.preventDefault();
                        if (previousCategory)
                            reviewPageFilterController.navigateToPreviousLevel(level - 1);
                        else
                            reviewPageFilterController.navigateToLevel(level - 1);
                    }
                    return <Link onClick={onClick} key={category} href="">{categoryLabel}</Link>
                })}
                {reviewPageFilterController.selectionCharts &&
                    !reviewPageFilterController.selectedCategory.length &&
                    !reviewPageFilterController.selectedPreviousCategory.length &&
                    <Typography color="textPrimary" className="">
                        Select a L{reviewPageFilterController.selectedLevel + 1}
                    </Typography>
                }
                {/*<Link color="inherit" href="/" onClick={handleClick}>*/}
                {/*    Material-UI*/}
                {/*</Link>*/}
                {/*<Link color="inherit" href="/getting-started/installation/" onClick={handleClick}>*/}
                {/*    Core*/}
                {/*</Link>*/}
                {/*<Typography color="textPrimary">Breadcrumb</Typography>*/}
            </Breadcrumbs>
        </Grid>
    </Grid>
})
